import { preferencesConstants } from "./constants";

export const setLanguage = (language: string) => {
    return {
        type: preferencesConstants.SET_LANGUAGE,
        payload: language,
    };
};

export const setDateFormat = (dateFormat: string) => {
    return {
        type: preferencesConstants.SET_DATE,
        payload: dateFormat,
    };
};

export const setTimeFormat = (timeFormat: string) => {
    return {
        type: preferencesConstants.SET_TIME,
        payload: timeFormat,
    };
};

export const setWeekStartDay = (weekStartDay: string) => {
    return {
        type: preferencesConstants.SET_WEEK_START_DAY,
        payload: weekStartDay,
    };
};

export const setUserPreferences = (
    language: string,
    dateFormat: string,
    timeFormat: string,
    weekStartDay: string
) => {
    return {
        type: preferencesConstants.SET_PREFERENCES,
        payload: {
            region: {
                language: language,
            },
            timeDateFormat: {
                dateFormat: dateFormat,
                timeFormat: timeFormat,
                weekStartDay: weekStartDay,
            },
        },
    };
};
